export const formatOrderAmount = (value) =>
  typeof value === "number" && Number.isFinite(value) ? `${value.toFixed(2)} €` : "Importe no disponible";

// The backend owns monetary calculations. Never fall back to legacy net fields.
export const orderTotal = (order) => formatOrderAmount(order?.amounts?.total);
